import { SVGProps } from 'react';

const Music2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0m0 0V2l7 4"
    />
  </svg>
);
export default Music2;
